import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storage = getStorage()
const storageRef = ref(storage, "firmwareFiles/");

export default {
    state:{
        firmwareVersionsList: [],
        loadingStatusFirmwareVersionFile:0,
    },
    mutations:{
        SET_FIRMWARE_VERSIONS_LIST(state, firmwareVersionsList){
            state.firmwareVersionsList = firmwareVersionsList
        },
        SET_VALUE_LOADING_STATUS_FIRMWARE_VERSION_FILE(state, progress) {
            state.loadingStatusFirmwareVersionFile = progress
        },
    },
    actions:{
        UploadFileFirmwareVersion({ commit }, firmwareVersion) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `firmwareFiles/${firmwareVersion.file.name}[${random}].json`);
                    const blob = new Blob([firmwareVersion.file.data], { type: 'application/json' });
                    let metadata = {
                        contentType: 'application/json'
                    }
                    
                    // Upload the blob
                    await uploadBytes(storageRef, blob, metadata);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: storageRef.name });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetFirmwareVersionsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "firmwareVersionsList"))
                    const firmwareVersionsList = []
                    querySnapshot.forEach(async(doc) =>  {
                        let firmwareVersion = doc.data()
                        firmwareVersionsList.push(firmwareVersion)
                    })
                    commit('SET_FIRMWARE_VERSIONS_LIST', firmwareVersionsList)
                    resolve(firmwareVersionsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetFirmwareVersion({ }, firmwareVersion){
            return new Promise(async (resolve, reject) => {
                try {
                    let resFirmwareVersion = await getDoc(doc(db, "firmwareVersionsList", firmwareVersion.id))
                    let gettedFirmwareVersion = resFirmwareVersion.data()
                    resolve(gettedFirmwareVersion)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateFirmwareVersion({}, firmwareVersion) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete firmwareVersion.file.data
                    const ref = doc(collection(db, "firmwareVersionsList"));
                    let newFirmwareVersion = await getDoc(ref);
                    firmwareVersion.id = ref.id;
                    firmwareVersion.createdAt = new Date()
                    firmwareVersion.updatedAt = new Date()
                    await setDoc(ref, firmwareVersion)
                    resolve(newFirmwareVersion.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateFirmwareVersion({}, firmwareVersion) {
            return new Promise(async(resolve, reject) => {
                try {
                    if (firmwareVersion.file.data) {
                        delete firmwareVersion.file.data
                    }
                    if(firmwareVersion.createdAt) {
                        delete firmwareVersion.createdAt
                    }
                    firmwareVersion.updatedAt = new Date()
                    await updateDoc(doc(db, "firmwareVersionsList", firmwareVersion.id), firmwareVersion)
                    resolve(firmwareVersion.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteFirmwareVersion({}, firmwareVersion) {
            return new Promise(async(resolve, reject) => {
                try {
                    let storageRef = ref(storage, `firmwareFiles/${firmwareVersion.file.ref}`);
                    await deleteObject(storageRef)
                    await deleteDoc(doc(db, "firmwareVersionsList", firmwareVersion.id))
                    resolve(firmwareVersion.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getFirmwareVersionsList(state){
            return state.firmwareVersionsList;
        },
        getLoadingStatusFirmwareVersionFile(state){
            return state.loadingStatusFirmwareVersionFile;
        },
    }
}